import { useState } from "react";
import TeamMemberModal from "../../Modal/TeamMemberModal";
import classes from "./TeamMember.module.css";

function renderHighlightedText(text, highlightWords) {
  if (!text) return null;

  const words = Array.isArray(highlightWords) ? highlightWords : [highlightWords];
  const validWords = words.filter(Boolean);

  if (!validWords.length) {
    return text;
  }

  const escapedWords = validWords.map((word) =>
    word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
  );
  const regex = new RegExp(`(${escapedWords.join("|")})`, "gi");

  return text.split(regex).map((part, index) => {
    const isHighlighted = validWords.some(
      (word) => part.toLowerCase() === word.toLowerCase(),
    );

    return isHighlighted ? (
      <span key={index} className={classes.highlight}>
        {part}
      </span>
    ) : (
      part
    );
  });
}

export default function TeamMember({
  heading = "",
  highlightWords = [],
  description = "",
  members = [],
}) {
  const [activeMember, setActiveMember] = useState(null);

  if (!Array.isArray(members) || !members.length) {
    return null;
  }

  return (
    <section className={classes.section} aria-labelledby="team-heading">
      <div className="container">
        {(heading || description) && (
          <div className={classes.intro}>
            {heading && (
              <h2 id="team-heading" className={classes.heading}>
                {renderHighlightedText(heading, highlightWords)}
              </h2>
            )}
            {description && (
              <p className={classes.description}>
                {description}
              </p>
            )}
          </div>
        )}

        <div className={classes.grid}>
          {members.map((member, index) => (
            <button
              type="button"
              key={member.id ?? member.name}
              className={classes.card}
              onClick={() => setActiveMember(member)}
              aria-haspopup="dialog"
            >
              <span className={classes.imageWrap}>
                <img
                  src={member.img}
                  alt={member.name}
                  className={classes.image}
                  loading="lazy"
                />
              </span>
              <span className={classes.name}>{member.name}</span>
              <span className={classes.designation}>{member.designation}</span>
            </button>
          ))}
        </div>
      </div>

      {activeMember && (
        <TeamMemberModal
          member={activeMember}
          onClose={() => setActiveMember(null)}
        />
      )}
    </section>
  );
}
